import type { CollectionBase } from '@/features/events/types';
import {
  type LaunchParams,
  toLaunchParams,
  type LaunchOption,
} from '@/hooks/useLauncher';
import type { DecoratedIntegration } from '@/pages/Schedule/hooks/useIntegrations';
import type { Calendar } from '@/types/gql.generated';

export const LAUNCH_KEY_GOOGLE_MULTI: LaunchOption = `google-add:all`;

export const isGoogleAddLaunch = (launch: LaunchOption): boolean =>
  launch?.startsWith('google-add:') ?? false;

/**
 * Use this for the Calendar button.
 * launch is omitted because it's added to the query by the button itself
 */
export const getRedirectQuery = (
  base: CollectionBase | null,
  params: LaunchParams = {}
) => {
  const query = toLaunchParams(params);

  if (base?.job?.id) {
    query.e = base.job.id;
  }

  return query;
};

export const getCalendarLink = (
  integration: DecoratedIntegration,
  calendar: Calendar
): string => {
  // https://webapps.stackexchange.com/questions/116392/how-to-get-a-link-to-add-a-google-calendar
  const id = calendar.id.endsWith('@resource.calendar.google.com')
    ? calendar.id
    : btoa(calendar.id).replaceAll('=', '');
  return `https://calendar.google.com/calendar/u/${integration.externalId}/r?cid=${id}`;
};
